<!-- TEMPLATE -->
<template>
    <div :class='contactDetailsClass'>
        <dean-two-column-layout :title="headerTitle">
            <dean-section-title-remove-restore
                v-if="canRemoveContact()"
                slot="title-items"
                :is-removed="isDeleted"
                text-remove="Verwijderen" :remove-icon="trashIcon" @remove="deleteContact"
                text-restore="Herstellen" :restore-icon="lockOpenIcon" @restore="restoreContact"
            >
            </dean-section-title-remove-restore>
            <dean-section-title-item
                v-if="canSaveContact()"
                :icon='saveIcon'
                slot="title-items"
                :content="true"
                :large="true"
                @click.native="processContact"
            >
                Opslaan
            </dean-section-title-item>
            <div class="column" slot="left">
                <dean-form-row id="givenName" v-model="contactData.personalName.givenName"
                               label="Voornaam"
                               @input="inputFieldChanged"
                               :required-field="true"
                               :disabled='!canSaveContact()'
                               :warning="$v.data.personalName.givenName.$error"></dean-form-row>
                <dean-form-row id="surnamePrefix" v-model="contactData.personalName.surnamePrefix"
                               label="Tussenvoegsels"
                               :disabled='!canSaveContact()'
                               @input="inputFieldChanged"></dean-form-row>
                <dean-form-row id="surname" v-model="contactData.personalName.surname" label="Achternaam"
                               @input="inputFieldChanged"
                               :required-field="true"
                               :disabled='!canSaveContact()'
                               :warning="$v.data.personalName.surname.$error"
                               @focus="$v.data.personalName.surname.$touch()"></dean-form-row>
                <dean-form-row id="jobTitle" v-model="contactData.personalName.jobTitle" label="Functietitel"
                               :disabled='!canSaveContact()'
                               @input="inputFieldChanged"></dean-form-row>
                <dean-form-row id="phoneNumber" v-model="data.phoneNumber" label="Telefoonnummer"
                               :disabled='!canSaveContact()'
                               @input="inputFieldChanged"
                               ></dean-form-row>
            </div>
            <div class="column" slot="right">
                <dean-form-row id="emailAddress" v-model="data.emailAddress" label="E-mailadres"
                               @input="inputFieldChanged"
                               :disabled='disableEmailAddressField || !canSaveContact()'
                               :required-field="true" :warning="$v.data.emailAddress.$error"
                               @focus="$v.data.emailAddress.$touch()"></dean-form-row>
                <dean-input-switch-form-row id="receivesInvoices" :value="contactData.receivesInvoices"
                                            :disabled='!canSaveContact()'
                                            @checked="inputSwitchChanged"
                                            label="Ontvangt facturen"></dean-input-switch-form-row>
                <dean-input-switch-form-row id="receivesNotifications" :value="contactData.receivesNotifications"
                                            :disabled='!canSaveContact()'
                                            @checked="inputSwitchChanged"
                                            label="Ontvangt berichten"></dean-input-switch-form-row>
            </div>
        </dean-two-column-layout>
    </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
  // VUE
  import {Component, Vue, Watch} from 'vue-property-decorator';
  import vSelect from 'vue-select';
  import axios from 'axios';
  import {deanDialogBus} from '@/main';
  import {validationMixin} from 'vuelidate';
  import {required, email} from 'vuelidate/lib/validators';
  import {Validations} from 'vuelidate-property-decorators';
  import {createNotification, validationMessage} from '@/mixins/validations'; // validationMessage used for error handling
  import {CollapseTransition} from 'vue2-transitions';

  import {
    customerIcon,
    businessIcon,
    commissionIcon,
    partnerIcon,
    deanAlertDialog,
    deanIcon,
    deanInputField,
    deanSearchField,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    invoicesIcon,
    messageIcon,
    offersIcon,
    ordersIcon,
    returnIcon,
    saveIcon,
    summeryIcon,
    usersIcon,
    lockOpenIcon,
    trashIcon,
    warningIcon,
  } from '@deanone/dean-components';
  import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
  import deanInputSelect from '@/components/deanComponents/deanInputSelect.vue';
  import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import DeanInputSwitchFormRow from '@/components/deanComponents/deanInputSwitchFormRow.vue';
  import deanSectionTitleRemoveRestore from '@/components/deanComponents/deanSectionTitleRemoveRestore.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import sideMenuPartnerMixin from '@/mixins/sideMenuPartnerMixin';
  import {mixins} from 'vue-class-component';
  import {authUserHasPrivilegeAndAction} from "@/mixins/privileges";
  import {UserPrivilege} from "@/enums/UserPrivilege";
  import {UserAction} from "@/enums/UserAction";

  @Component({
    components: {
      deanSectionTitleRemoveRestore,
      DeanInputSwitchFormRow,
      DeanSelectFormRow,
      deanAlertDialog,
      deanInputField,
      DeanTwoColumnLayout,
      deanInputSelect,
      deanFormRow,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      vSelect,
      invoicesIcon,
      deanIcon,
      returnIcon,
      saveIcon,
      summeryIcon,
      partnerIcon,
      businessIcon,
      usersIcon,
      offersIcon,
      ordersIcon,
      commissionIcon,
      messageIcon,
      CollapseTransition,
    },
    mixins: [validationMixin],
  })

  export default class Details extends mixins(sideMenuPartnerMixin) {
    public saveIcon: object = saveIcon;
    public lockOpenIcon: object = lockOpenIcon;
    public trashIcon: object = trashIcon;
    public showSomething: boolean = false;
    public timeout?: number;
    public data: {
      id: any,
      organizationId: any,
      personalName: {
        givenName: any,
        additionalName: any,
        surnamePrefix: any,
        surname: any,
        jobTitle: any,
        nameStyle: any,
      },
      emailAddress: any,
      phoneNumber: any,
      receivesInvoices: any,
      receivesNotifications: any,
    } = {
      id: null,
      organizationId: null,
      personalName: {
        givenName: null,
        additionalName: null,
        surnamePrefix: null,
        surname: null,
        jobTitle: null,
        nameStyle: null,
      },
      emailAddress: null,
      phoneNumber: null,
      receivesInvoices: false,
      receivesNotifications: false,
    };
    public state: string = '';
    public isDeleted: boolean = false;

    // COMPUTED
    @Validations()
    get validations() {
      const valData: any = {
        data: {
          personalName: {
            surname: {required},
            givenName: {required},
          },
          emailAddress: {required, email},
        },
      };

      return valData;
    }

    get contactDetailsClass() {
      let value = 'partner-add';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get contactData() {
      return this.data;
    }

    get headerTitle(): string {
      return (this.$route.params.contactId !== undefined) ? 'Contact wijzigen' : 'Contact toevoegen';
    }

    get disableEmailAddressField() {
      return false;
    }

    public inputSwitchChanged(field: { id: any, value: any }) {
      const key: string = field.id;
      // @ts-ignore-next-line
      this.data[key] = field.value;
    }

    public inputFieldChanged(field: any) {
      const name: string = field.id;
      // @ts-ignore-next-line
      this.data[name] = field.value;
    }

    public contactDetails(): Promise<boolean> {
      return new Promise((resolve, reject) => {
        if (this.$route.params.contactId) {
          this.$store.dispatch('setLoadOverlay', true);
          axios.post('/-/trade/api/partner.contact.info', {
            contactId: this.$route.params.contactId,
          }).then(
            (response) => {
              // Check if contact is deleted
              this.isDeleted = Boolean(response.data.deleted);

              console.log(this.isDeleted);

              if (this.$route.params.contactId != null) {
                this.data = {...this.data, ...response.data};
              }
            },
            (error) => {
              this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
            },
          ).finally(
            () => {
              this.$store.dispatch('setLoadOverlay', false);
            },
          );
        }
      });
    }

    public created() {
      this.contactDetails();
      this.buildSideMenuPartner();
    }

    public deleteContact() {
      deanDialogBus.$emit('open', 'DeleteContactDialog', {
        id: this.$route.params.contactId,
        context: 'partners',
        contextId: this.$route.params.pid,
        givenName: this.data.personalName.givenName,
        surnamePrefix: this.data.personalName.surnamePrefix,
        surname: this.data.personalName.surname,
      });
    }

    public restoreContact() {
      deanDialogBus.$emit('open', 'DeleteContactDialog', {
        id: this.$route.params.contactId,
        context: 'partners',
        contextId: this.$route.params.pid,
        givenName: this.data.personalName.givenName,
        surnamePrefix: this.data.personalName.surnamePrefix,
        surname: this.data.personalName.surname,
        state: 'restoring',
      });
    }

    public processContact() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$store.dispatch('setLoadOverlay', true);

        const url = '/-/trade/api/partner.contact.save';

        this.data.organizationId = this.$route.params.pid;

        axios
          .post(url, this.contactData).then(
          (response) => {
            this.$toast({
              icon: saveIcon,
              text: 'Contact opgeslagen',
              theme: 'success',
            });
            this.$store.dispatch('setLoadOverlay', false);
          },
          (error) => {
              if (error.response.data.errors) {
                let errorText = 'Fout';

                switch (error.response.data.errors[0].code) {
                  case 'ERR_EMAIL_NOT_UPDATEABLE':
                    errorText = 'Kan het e-mailadres van een contactpersoon die een gebruiker is, niet bijwerken.';
                    break;
                  case 'ERR_EMAIL_NOT_AVAILABLE':
                    errorText = 'E-mailadres is niet beschikbaar.';
                    break;
                }

                this.$toast(validationMessage(errorText));
              } else {
                this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
              }
              this.$store.dispatch('setLoadOverlay', false);
          },
        );
      } else {
        this.$toast(createNotification(this.$v));
      }
    }

    public canSaveContact(): boolean {
      if (this.isDeleted) {
        return false;
      }

      if (
          this.data?.id
          && authUserHasPrivilegeAndAction(UserPrivilege.CONTACT, UserAction.UPDATE)
      ) {
        return true;
      }

      if (
          this.data?.id === null
          && authUserHasPrivilegeAndAction(UserPrivilege.CONTACT, UserAction.CREATE)
      ) {
        return true;
      }

      return false;
    }

    public canRemoveContact(): boolean {
      if (
          this.$route.name === 'partner.contact.edit'
          && authUserHasPrivilegeAndAction(UserPrivilege.CONTACT, UserAction.CHANGE_STATUS)
      ) {
        return true;
      }

      return false;
    }

    public mounted() {
      deanDialogBus.$on('contactStatusChange', () => {
        this.contactDetails();
      });
    }

    public destroyed() {
      deanDialogBus.$off('contactStatusChange');
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
    @import '~@deanone/dean-components/src/scss/vars';
</style>